// extracted by mini-css-extract-plugin
module.exports = {"imagesection":"ImageSection__imagesection--Kxdyp","label":"ImageSection__label--oNS3Q"};